import React from "react";
import { MenuItem as IMenuItem } from "@app/api/core/menu-item/menu-item";
import { IconComponent } from "@app/core";
import IcnChevronRight from "@assets/icons/chevron-right-sharp.svg";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";

import { PriorityMenuItem } from "../priority-menu-item/priority-menu-item";
import styles from "../new-mobile-nav-bar-component.module.scss";

interface IProps {
  menuItem: IMenuItem;
  expandMenuItem: (menuItem: IMenuItem) => void;
  closeMenu: () => void;
  index: number;
}

export const component = (props: IProps & RouteComponentProps) => {
  const hasChildren = props.menuItem.children && props.menuItem.children.length > 0;

  const expandMenuItem = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    if (hasChildren) {
      props.expandMenuItem(props.menuItem);

      return;
    }

    props.history.push(props.menuItem.url || "#");
    props.closeMenu();
  };

  const onClick = () => {
    props.closeMenu();
  };

  if (props.index < 2) {
    return <PriorityMenuItem onClick={onClick} menuItem={props.menuItem} index={props.index} />;
  }

  return (
    <div className={styles.menuItem}>
      <Link onClick={onClick} className={styles.title} to={props.menuItem.url || ""}>
        {props.menuItem.title}
      </Link>
      {hasChildren && (
        <button onClick={expandMenuItem} className={styles.icon}>
          <IconComponent icon={IcnChevronRight} size="12px" />
        </button>
      )}
    </div>
  );
};

const NewMenuItem = withRouter(component);
export { NewMenuItem };
